const PLATFORMS = {
  DPONET: 'dponet',
  DPO_EASY: 'dpo_easy',
  ADVISOR: 'advisor',
}

const STATUSES = {
  ACTIVE: 'active',
  DRAFT: 'draft',
  INACTIVE: 'inactive',
}

const FORM_TYPES = {
  EDIT: 'edit',
  SHOW: 'show',
}

const PLATFORM_LABEL = {
  [PLATFORMS.DPONET]: 'DPOnet',
  [PLATFORMS.DPO_EASY]: 'DPO Easy',
  [PLATFORMS.ADVISOR]: 'Advisor',
}

const STATUS_LABEL = {
  [STATUSES.ACTIVE]: 'Ativo',
  [STATUSES.DRAFT]: 'Rascunho',
  [STATUSES.INACTIVE]: 'Inativo',
}

const PLATFORMS_OPTIONS = [
  { id: PLATFORMS.DPONET, name: PLATFORM_LABEL[PLATFORMS.DPONET] },
  { id: PLATFORMS.DPO_EASY, name: PLATFORM_LABEL[PLATFORMS.DPO_EASY] },
  { id: PLATFORMS.ADVISOR, name: PLATFORM_LABEL[PLATFORMS.ADVISOR] },
]

const TABS = [
  {
    value: 'all',
    label: 'Todos',
  },
  {
    value: STATUSES.ACTIVE,
    label: 'Ativos',
  },
  {
    value: STATUSES.DRAFT,
    label: 'Rascunhos',
  },
  {
    value: STATUSES.INACTIVE,
    label: 'Inativos',
  },
]

const regulations = {
  FORM_TYPES,
  PLATFORM_LABEL,
  PLATFORMS,
  PLATFORMS_OPTIONS,
  STATUS_LABEL,
  STATUSES,
  TABS,
}

export default regulations
